import { useMutation } from "@tanstack/react-query";
import { exportInvoiceToPdf } from "../../api/apiInvoices";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";

export const useExportInvoicePdf = () => {
    const { i18n } = useTranslation();
    const lang = i18n.language;

    const { mutate: exportInvoicePdfMutate, isPending } = useMutation({
        mutationFn: ({ id, data }) => exportInvoiceToPdf(id, data),
        onSuccess: (response, variables) => {
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', variables.data.filename || `invoice_${variables.id}.pdf`);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
            toast.success(lang === "ar" ? "تم تصدير الفاتورة بنجاح" : "Invoice exported successfully");
        },
        onError: (error) => {
            const errorMessage =
                error.response?.data?.message ||
                (lang === "ar" ? "حدث خطأ أثناء تصدير الفاتورة" : "An error occurred while exporting the invoice");
            toast.error(errorMessage);
        },
    });

    return { exportInvoicePdfMutate, isPending };
};

export default useExportInvoicePdf;
